import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Posts from "@/pages/Posts";
import AIAssistant from "@/pages/AIAssistant";
import TelegramChannels from "@/pages/TelegramChannels";
import TelegramPartnerChannels from "@/pages/TelegramPartnerChannels";
import SocialMedia from "@/pages/SocialMedia";
import RSSFeeds from "@/pages/RSSFeeds";
import Streaming from "@/pages/Streaming";
import StreamingManager from "@/pages/StreamingManager";
import Automation from "@/pages/Automation";
import MediaLibrary from "@/pages/MediaLibrary";
import Stats from "@/pages/Stats";
import Settings from "@/pages/Settings";
import UsersPage from "@/pages/Users";
import Notifications from "@/pages/Notifications";
import TelegramLive from "@/pages/TelegramLive";
import ErrorBoundary from "@/components/ErrorBoundary";
import WatchPage from "./pages/Watch";

function App() {
  return (
    <div className="App dark min-h-screen bg-slate-950">
      <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
          <Route path="/watch/:id" element={<WatchPage />} />
            <Route path="/login" element={<Login />} />
            <Route element={<AppLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/posts" element={<Posts />} />
              <Route path="/ai" element={<AIAssistant />} />
              <Route path="/telegram" element={<TelegramChannels />} />
              <Route path="/telegram-partner-channels" element={<TelegramPartnerChannels />} />
              <Route path="/telegram-live" element={<TelegramLive />} />
              <Route path="/social" element={<SocialMedia />} />
              <Route path="/rss" element={<RSSFeeds />} />
              <Route path="/streaming" element={<Streaming />} />
              <Route path="/streaming-manager" element={<StreamingManager />} />
              <Route path="/automation" element={<Automation />} />
              <Route path="/media" element={<MediaLibrary />} />
              <Route path="/stats" element={<Stats />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/notifications" element={<Notifications />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
